import { ICompanyMember } from '../common/models/Company'

/** Filter value standing for "has no domain" — jobs the company never put in a
 * department still have to be selectable. */
export const NO_DOMAIN_KEY = '__other__'

export const domainFilterMatchesJob = (
  domainFilter: string[],
  departmentId?: string
): boolean => {
  if (domainFilter.length === 0) return true
  return domainFilter.includes(
    departmentId ? String(departmentId) : NO_DOMAIN_KEY
  )
}

export const jobFilterMatchesLevel = (
  jobFilter: string[],
  jobId: string,
  levelId: string
): boolean => {
  if (jobFilter.length === 0) return true
  if (jobFilter.includes(jobId)) return true
  return jobFilter.includes(levelId)
}

export const culturalPhaseMatches = (
  filter: string[],
  cultureRankId?: string
): boolean => {
  if (filter.length === 0) return true
  return cultureRankId !== undefined && filter.includes(cultureRankId)
}

export const memberPassesTeamFilter = (
  teamFilter: string[],
  member: ICompanyMember
): boolean => {
  if (teamFilter.length === 0) return true
  return member.teams.some((t) => teamFilter.includes(t.teamId))
}

export const memberPassesJobFilter = (
  jobFilter: string[],
  member: ICompanyMember
): boolean => {
  if (jobFilter.length === 0) return true
  if (!member.job) return false
  if (jobFilter.includes(member.job.jobId)) return true
  if (member.job.jobLevelId && jobFilter.includes(member.job.jobLevelId)) {
    return true
  }
  return false
}

export const memberPassesCulturalPhaseFilter = (
  filter: string[],
  member: ICompanyMember
): boolean => culturalPhaseMatches(filter, member.jobLevel?.cultureRankId)
